import React, { useRef } from 'react';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import CustomFlatList from 'src/components/10-atoms/list-views/CustomFlatList';
import isDeepEqual from 'src/utils/object/isDeepEqual';
import styleUtils from 'src/utils/styles';
import useListState from './useListState';
import { renderNamedSlot } from 'src/utils/component';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
function GQLPaginatedList({ LoaderComponent, NextLoaderComponent = LoaderComponent, ErrorComponent, ListEmptyComponent, EndOfListComponent = null, queryState, queryActions, variables, renderItem, style, ...listProps }) {
    const prevVariables = useRef();
    useEffectWithCtx(ctx => {
        if (!isDeepEqual(variables, prevVariables.current)) {
            ctx.queryActions.refresh(variables);
            prevVariables.current = variables;
        }
    }, { queryActions }, [variables]);
    const handleRetry = () => {
        queryActions.refresh(variables);
    };
    const handleEndReached = () => {
        queryActions.fetchMore(variables);
    };
    const handleRefresh = () => {
        queryActions.refresh(variables);
    };
    const renderListItem = ({ item, ...props }) => {
        switch (item.type) {
            case 'list_loading':
                return renderNamedSlot(LoaderComponent);
            case 'list_empty':
                return renderNamedSlot(ListEmptyComponent);
            case 'list_error':
                return renderNamedSlot(ErrorComponent || (React.createElement(GenericServerError, { error: queryState.error, onRetry: handleRetry })));
            case 'end_of_list':
                return renderNamedSlot(EndOfListComponent);
            case 'list_data':
                return renderItem ? renderItem({ item: item.data, ...props }) : null;
            default:
                return null;
        }
    };
    const [listState] = useListState(queryState);
    return (React.createElement(CustomFlatList, { initialRenderDelay: 50, data: listState.data, renderItem: renderListItem, style: [styleUtils.containerHeight, style], keyExtractor: item => item.type !== 'list_data'
            ? item.type
            : item.data.id, onEndReached: () => listState.query.empty ? undefined : handleEndReached(), onEndReachedThreshold: 0.5, ListFooterComponent: queryState.data?.hasMore ? NextLoaderComponent : null, refreshing: queryState.refetching, onRefresh: handleRefresh, ...listProps }));
}
export default GQLPaginatedList;
